import { render, staticRenderFns } from "./disease-forecast.vue?vue&type=template&id=aa668da2&scoped=true"
import script from "./disease-forecast.vue?vue&type=script&lang=js"
export * from "./disease-forecast.vue?vue&type=script&lang=js"
import style0 from "./disease-forecast.vue?vue&type=style&index=0&id=aa668da2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa668da2",
  null
  
)

export default component.exports